export default {
      id: "oc-cas-usage",
      viewBox: "0 0 44 25",
      url: __webpack_public_path__ + "sprite.svg#oc-cas",
      toString: function () {
        return this.url;
      }
    }